import { render, staticRenderFns } from "./Two-Factor-For-Data.html?vue&type=template&id=58b4f1bf&scoped=true&external"
import script from "./Two-Factor-For-Data.js?vue&type=script&lang=js&external"
export * from "./Two-Factor-For-Data.js?vue&type=script&lang=js&external"
import style0 from "./Two-Factor-For-Data.scss?vue&type=style&index=0&id=58b4f1bf&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b4f1bf",
  null
  
)

export default component.exports